// AUTO-GENERATED from Firestore dump. Do not edit by hand.
// Source: scripts/build-static-config.mjs (config version 23)

import type { TvmFormDefinition } from "../types";

const form: TvmFormDefinition = {
	"description": "Guinches",
	"formula": {
		"guincheCapacityB": "(drumWidth*(maxDiameter**2-minDiameter**2))/(1400*cableDiameter**2)",
		"cableWeight": "cableWeight*((drumWidth*(maxDiameter**2-minDiameter**2))/(1560*cableDiameter**2))",
		"cableWeight90": "0.9*cableWeight*((drumWidth*(maxDiameter**2-minDiameter**2))/(1560*cableDiameter**2))",
		"cableWeightB": "cableWeight*((drumWidth*(maxDiameter**2-minDiameter**2))/(1400*cableDiameter**2))",
		"cableWeight90B": "0.9*cableWeight*((drumWidth*(maxDiameter**2-minDiameter**2))/(1400*cableDiameter**2))",
		"guincheCapacity": "(drumWidth*(maxDiameter**2-minDiameter**2))/(1560*cableDiameter**2)"
	},
	"fields": {
		"cableDiameter": {
			"inputType": "number",
			"index": 3,
			"label": "$form_winches_cable_diameter",
			"type": "INPUT",
			"name": "cableDiameter",
			"value": 0
		},
		"maxDiameter": {
			"label": "$form_winches_max_diameter",
			"index": 0,
			"type": "INPUT",
			"inputType": "number",
			"name": "maxDiameter",
			"value": 0
		},
		"minDiameter": {
			"name": "minDiameter",
			"value": 0,
			"index": 1,
			"label": "$form_winches_min_diameter",
			"type": "INPUT",
			"inputType": "number"
		},
		"cableWeight": {
			"inputType": "number",
			"index": 4,
			"label": "$form_winches_cabe_weight",
			"type": "INPUT",
			"name": "cableWeight",
			"value": 0
		},
		"drumWidth": {
			"inputType": "number",
			"type": "INPUT",
			"index": 2,
			"label": "$form_winches_drump_width",
			"value": 0,
			"name": "drumWidth"
		}
	},
	"hints": {
		"htmlDef": "<div style=\"font-family: Helvetica; font-size: 22px;\">    <p>{{form_winches_hints_img_1}}</p>    <p>{{form_winches_hints_img_2}}</p>    <br>    <p>{{form_winches_hints_p1}}</p>    <p>{{form_winches_hints_p1}}</p>    <p>{{form_winches_hints_p2}}</p>    <p>{{form_winches_hints_p3}}</p> </div>",
		"title": "Guinches"
	}
};

export const guinches = form;
